import { render } from "./modalCreate.vue?vue&type=template&id=2d47f36c&scoped=true"
import script from "./modalCreate.vue?vue&type=script&lang=js"
export * from "./modalCreate.vue?vue&type=script&lang=js"

import "./modalCreate.vue?vue&type=style&index=0&id=2d47f36c&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d47f36c"]])

export default __exports__